module.exports = __webpack_public_path__ + "static/media/soona-logo.3f9cd77e.svg";